import styled from 'styled-components';

import * as FiIcons from 'react-icons/fi';

export const StyledErrorWrap = styled.p`
  font-size: 12px;
  font-weight: 400;
  padding: 0 16px;
  color: red;
`;

export const BenefitsSettingsWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 10px;
`;

export const BenefitsSettingHeader = styled.p`
  text-align: left;
  font: normal normal bold 20px/31px Biotif;
`;

export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
`;

export const GalleryHeader = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal normal 20px/30px Biotif;
`;

export const EmptyGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

type GalleryCardImgType = { selected?: boolean };

export const GalleryCardImg = styled.div<GalleryCardImgType>`
  display: flex;
  flex-grow: 2;
  width: 215px;
  max-width: 215px;
  height: 215px;
  border-radius: 4px 4px 0 0;
  justify-content: flex-end;
  margin: 2px;

  border: ${props => (props.selected ? '3px solid #2DCAFC' : '')};
  background-position: center;
  background-size: cover;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const GalleryScrollableContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  max-height: 500px;
  gap: 20px;
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FileUploadWrapper = styled.div`
  display: 'flex';
  background: #f3f4f8;
  display: flex;
  align-self: center;
  border-radius: 10px;
`;

export const FileUploadWrapperRemove = styled.div`
  display: flex;
  align-self: center;
  padding-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;

export const WarningText = styled.p`
  font-size: 12pt;
  color: rgba(214, 24, 11);
`;

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

// Texts
export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
  max-width: 49ch;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FormTitle = styled.h3`
  margin: 0;
  text-align: center;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

// Inputs
export const FormWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: flex-end;
  justify-content: flex-end;

  padding: 30px;
  width: 100%;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const Input = styled.input`
  display: block;
  height: 35px;
  font-size: 1.4rem;
  color: #222247;

  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;

export const TextAreaInput = styled.textarea`
  display: block;
  font-size: 1.4rem;
  color: #222247;
  height: 200px;
  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const InputLabel = styled.div`
  color: '#222247';
`;

export const BenefitFormTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: 'center';
`;

export const BenefitFormContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  height: 500px;
  margin-top: 10px;
  padding: 0px 20px 20px 20px;
`;
